import { Button } from '@/components/ui/button';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { conversationStartErrorCode } from '../lib/conversation-start-error';

interface StreamErrorBannerProps {
  message: string | null;
  onRetry: () => void;
}

/** Inline error shown above the composer when a stream fails mid-flight. */
export function StreamErrorBanner({
  message,
  onRetry,
}: StreamErrorBannerProps) {
  let safeMessage = 'Claire couldn’t finish this response. Please try again.';
  const code = conversationStartErrorCode(message);
  if (code === 'CONVERSATION_BUSY') {
    safeMessage =
      'Claire is still finishing the previous reply. Your message has not been sent. Wait a moment, then retry.';
  } else if (code === 'CONVERSATION_LOCK_UNAVAILABLE') {
    safeMessage =
      'Claire could not start this reply safely. Your message has not been sent. Please retry in a moment.';
  }
  return (
    <div className="flex justify-start">
      <div className="flex items-center gap-2 rounded-lg border border-destructive/30 bg-destructive/5 px-4 py-2.5 text-sm text-destructive dark:bg-destructive/10">
        <AlertCircle className="size-4 shrink-0" />
        <span className="flex-1">{safeMessage}</span>
        <Button
          type="button"
          size="sm"
          variant="outline"
          className="ml-2 gap-1.5 border-destructive/30 text-destructive hover:bg-destructive/10"
          onClick={onRetry}
        >
          <RefreshCw className="size-3.5" />
          Retry
        </Button>
      </div>
    </div>
  );
}

interface ConversationNotFoundProps {
  className?: string;
}

export function ConversationNotFound({ className }: ConversationNotFoundProps) {
  return (
    <div
      className={
        className ??
        'flex flex-1 items-center justify-center text-sm text-muted-foreground'
      }
    >
      Conversation not found
    </div>
  );
}
